import axios from "axios";
appHost.actions.register({
    // #region Vars
    name: '288a.layouts.dataLoadFromUrl',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Check
        if (!params.url) {
            return this.Cancel();
        }
        // #endregion
        // #region Run
        try {
            // #region Load
            let tResult = await axios.get(params.url);
            // #endregion
            return this.Ok(tResult.data);
        }
        catch (e) {
            return this.Error(e);
        }
        // #endregion       
    },
    // #endregion
});
